import { render, staticRenderFns } from "./DisplayView.vue?vue&type=template&id=8545ff16&"
import script from "./DisplayView.vue?vue&type=script&lang=js&"
export * from "./DisplayView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports